import { Link, useNavigate } from "react-router-dom";
import englishTagline from "application/images/EnglishTagline.svg";
import frenchTagline from "application/images/FrenchTagline.svg";
import portugueseTagline from "application/images/PortugueseTagline.svg";
import danishTagline from "application/images/DanishTagline.svg";
import logo from "application/images/1link.png";
import styles from "./Header.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

const Header = () => {

    const layoutState = useSelector((state: RootState) => state.layout);
    const { data, error } = layoutState;
    const region = useSelector((state: RootState) => state.region.region);
    const navigate = useNavigate();
    const taglineMap: { [key: string]: string } = {
        UK: englishTagline,
        IE: englishTagline,
        AU: englishTagline,
        FR: frenchTagline,
        PT: portugueseTagline,
        DK: danishTagline,
    };
    if (error) return <p>Error: {error}</p>;
    if (!data || !data.topLinks) return null;

    return (
        <div>
            <header className="container-fluid py-3">
                <div className="row">
                    <div className="col-auto d-flex align-items-center ps-3">
                        <img src={logo} alt="1link Logo" className={`${styles.logo} me-3 mb-1 mt-1`} height="60" onClick={() => navigate("/")} />
                        <img
                            src={taglineMap[region]}
                            alt="Fleet Technology Tagline"
                            className={`${styles.taglineImage} ${region === "FR" ? "mb-2" : ""}`}
                        />
                    </div>
                    <div className="col-md d-flex justify-content-end pe-4">
                        <nav>
                            {data.topLinks.map(({ title, url }: { title: string; url: string }, id: number) => (
                                <Link to={url} key={id} className={`${styles.linkButtons} text-decoration-none me-3 pb-0`}>
                                    <span>{title}</span>
                                </Link>
                            ))}
                        </nav>
                    </div>
                </div>
            </header>
        </div>
    );
};

export default Header;
